import React, { Suspense } from 'react';
import AWS from 'aws-sdk';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import history from './components/utilities/History';

// Components
import { ApplicationSpinner, Loading } from '@zawarski/palmetto-ui-components';

import './styles/palmetto-tabs.css';
import './styles/common.css';
import './styles/common.login.css';
import './styles/map-styles.css';
// import "./styles/palmetto-direflow-react-table.css";
import '@zawarski/palmetto-ui-components/dist/styles/common.css';
import '@zawarski/palmetto-ui-components/dist/styles/iron-flex-layout.css';
import '@zawarski/palmetto-ui-components/dist/styles/iron-flex-layout-classes.css';

const HomeComponent = React.lazy(() => import('./components/app/Home'));

AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID, // Generated on step 1
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY, // Generated on step 1
  region: 'us-east-1', // Must be the same as your bucket
  signatureVersion: 'v4',
});

function App() {
  const appLoading = useSelector((state) => state.rootReducer.appLoading);
  return (
    <>
      {appLoading ? (
        <div className='layout vertical vertical-center full-height'>
          <ApplicationSpinner />
          <div className='height-20'></div>
          <span style={{ padding: '0 16px' }} className='text-center title-big opacity-54'>
            Loading the app
          </span>
        </div>
      ) : (
        <div className='full-height'>
          <Router history={history}>
            {/* id can be extracted from props.match.params.id */}
            <Switch>
              <Route
                path='/'
                component={(props) => (
                  <Suspense fallback={<Loading />}>
                    <HomeComponent {...props} />
                  </Suspense>
                )}
              />
            </Switch>
          </Router>
        </div>
      )}
    </>
  );
}

export default App;
